/**
 * Conference identity shown in the headers of the public registration flow
 * (the pre-registration pages and the registration steps).
 *
 * Kept in one place so the conference name and dates cannot drift apart
 * between the pages that display them.
 */
export const CONFERENCE_TITLE = 'AlUla Conference for Emerging Market Economies (ACEME)';
// Three lines: the classes that display it (.preRegSub, .regMobileHeroSub) use `white-space: pre-line`.
export const CONFERENCE_SUBTITLE = 'Third Annual Conference | 21–22 March 2027\nAlUla, Kingdom of Saudi Arabia\nReimagining Resilience in a Changing Global Economy';
export const CONFERENCE_EDITION = 'ACEME 2027';

/**
 * Event dates + venue, shown at the top of the profile dashboard's
 * "Your Participation" panel. Kept beside CONFERENCE_SUBTITLE (which also
 * carries the country) so the dashboard can print the shorter venue line.
 */
export const CONFERENCE_VENUE_LINE = '21-22 March 2027 • Maraya Hall, AlUla';

/**
 * Cut-off date printed in the profile dashboard banner while the delegate still
 * has to submit flight details. The API exposes no deadline field yet, so this
 * constant is the single place to change it.
 */
export const FLIGHT_DETAILS_DUE_BY = 'All travel and accommodation details are due by 07 February 2027.';
